<div class="container">
  <h2 class="mb-4">VendorMembers List</h2>

  <!-- Dropdown to select a vendor -->
  <div class="mb-3">
    <!-- <label for="vendorSelect" class="form-label" style="text-align: left; width: 100vw;">Select Vendor</label> -->
    <select id="vendorSelect" class="form-select" [(ngModel)]="selectedVendorId" (change)="filterVendorMembers()">
      <option value="" selected>All Vendors</option>
      <option *ngFor="let vendor of vendorsData" [value]="vendor.id">{{ vendor.vendorName }}</option>
    </select>
  </div>

  <table class="table table-bordered">
    <thead>
      <tr>
        <th>Vendor</th>
        <th>VendorMember Name</th>
        <th>Email</th>
        <th>Mobile</th>
        <th>Skype ID</th>
        <th>Telephone</th>
        <th>Is WhatsApp</th>
        <th>Actions</th> <!-- Actions column -->
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let vendormember of filteredVendorMembersData">
        <td>{{ getVendorName(vendormember.vendorId) }}</td> <!-- Display vendor name based on vendorId -->
        <td>{{ vendormember.memberName }}</td>
        <td>{{ vendormember.email }}</td>
        <td>{{ vendormember.mobile }}</td>
        <td>{{ vendormember.skypeId || '-' }}</td>
        <td>{{ vendormember.telephone || '-' }}</td>
        <td>
          <span *ngIf="vendormember.isWhatsApp" class="text-success">✔️</span>
          <span *ngIf="!vendormember.isWhatsApp" class="text-danger">❌</span>
        </td>
        <td>
          <button class="btn btn-secondary btn-sm" (click)="updateVendorMember(vendormember)"
            [disabled]="!hasPermission('VendorMembersAddNewVendorMemberPermission')">Update</button>
          <button class="btn btn-danger btn-sm" (click)="deleteVendorMember(vendormember)">Delete</button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
